"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Link from "next/link";
import { sliderData } from "../../../data/topBanner/sliderData";
import { ArrowRight } from "lucide-react";

export default function TopSlider() {
  return (
    <Swiper
      modules={[Autoplay]}
      slidesPerView={1}
      loop
      speed={800}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      className="w-full h-screen"
    >
      {sliderData.map((slide) => (
        <SwiperSlide key={slide.id}>
          <div
            className="flex items-center justify-center md:justify-start w-full h-screen bg-cover bg-no-repeat relative transition-all duration-700"
            style={{
              backgroundImage: `url(${slide.image})`,
              backgroundPosition: "center center",
            }}
          >
            {/* dark overlay */}
            <div className="absolute inset-0 bg-black/30"></div>

            {/* content */}
            <div className="relative z-10 flex flex-col items-center md:items-start justify-center w-[90%] md:w-3/5 h-full px-4 md:pl-35 mt-30 md:mt-40">
              <div className="flex flex-col items-center md:items-start justify-center w-full md:w-[90%] py-8 md:py-10 px-6 md:px-10 bg-white/20 backdrop-blur-xl text-center md:text-left">
                <h2 className="text-3xl sm:text-4xl md:text-[52px] font-bold font-lora text-white mb-4 md:mb-6 drop-shadow-lg">
                  {slide.title}
                </h2>
                <p className="text-base sm:text-lg md:text-xl text-gray-100 mb-6 md:mb-8 w-full md:w-[90%]">
                  {slide.description}
                </p>
                <Link
                  href={slide.button.link}
                  className="flex items-center justify-center gap-2 bg-accent text-white font-medium px-5 py-3 md:px-6 md:py-3 rounded-md transition-all duration-300 hover:bg-accent/90"
                >
                  {slide.button.text} <ArrowRight size={18} />
                </Link>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
